export default __webpack_public_path__ + "static/media/Leggings of the Nebulous.82a45ec7.jpg";